import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { LoginService } from '../../../../services/authentication/login.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'app-kpicustserv',
  templateUrl: './kpicustserv.component.html',
  styleUrls: ['./kpicustserv.component.css']
})
export class KpicustservComponent extends BaseCrudComponent {

  	@ViewChild('myCanvas', {static: false}) myCanvas: ElementRef;

  	exportAsConfig: ExportAsConfig = {
        type: 'xlsx',
        elementIdOrContent: 'exportable'
    };

  	translations:any;
	header:any;
	theaders:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    
    totals:any;
    frozenCols:any;
    loadingRequired = false;

    //filters data
    dropdowns:any;
    sr_filter:any;
    hr_filter:any;
    driver_filter:any;
    ds_filter:any;
    rs_filter:any;

    sel_delivery:any;
    summary_1:any;
    summary_2:any;
    summary_3:any;

    // Bars
  	public barChartLabels: string[] = ['Total'];
    public barChartLabels2: string[] = [];
  	
  	public barChartData: any = [
  		{data:[], label:''}
  	];

    public barChartData2: any = [
        {data:[], label:''}
    ];

  	public barChartOptions: any = {
	    scaleShowVerticalLines: false,
	    responsive: true,
	    barThickness: 10
	};

  	// Pie
  	public pieChartLabels: string[] = [];
  	
  	public pieChartData: any = [
  		{data:[], label:''}
  	];

    public branches:any;
    public SubsidiaryId:any;
    public usr_subsidiary:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService,
        private login: LoginService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'LogisticKpis/CustomerService';
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.dropdowns = [];
        this.barChartData = null;
        this.barChartData2 = null;
        this.pieChartData = null;

        this.summary_1 = [];
        this.summary_2 = [];
        this.summary_3 = [];

        this.frozenCols = [
            //{ field: 'guideNumber', header: 'Guia', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'}
        ];

        this.theaders = [
        	{ field: 'driver', header: 'Conductor', sortable:true, sortfield:'driver', styleC:{'text-align':'center'}, width:{'width.px': 220}, isColor:false, pre:'', pos:'', total:'', filter:'input', chart:false},
            { field: 'groupDriver', header: 'Grupo', sortable:true, sortfield:'groupDriver', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'guideDate', header: 'Fecha', sortable:true, sortfield:'guideDate', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'guideNumber', header: 'Guía', sortable:true, sortfield:'guideNumber', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'clientName', header: 'Nombre Cliente', sortable:true, sortfield:'clientName', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'recipientCode', header: 'Código Cliente', sortable:true, sortfield:'recipientCode', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'clientType', header: 'Tipo Cliente', sortable:true, sortfield:'clientType', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'departureDate', header: 'Fecha de salida de CD', sortable:true, sortfield:'departureDate', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'deliveredTime', header: 'Fecha entregado', sortable:true, sortfield:'deliveredTime', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'totalDeliveryDays', header: 'Total días de entrega', sortable:true, sortfield:'totalDeliveryDays', styleC:{'text-align':'right'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'fulfillment', header: 'Cumplimiento', sortable:true, sortfield:'fulfillment', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'score', header: 'Calificación Servicio al Cliente', sortable:true, sortfield:'score', styleC:{'text-align':'right'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false}
        ];

        this.branches = [];
        this.SubsidiaryId = null;
        this.usr_subsidiary = -1;
    }

    ngOnInit() {
        this.clearFilters();

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
            this.translations = translations;
            super.ngOnInit();

            this.getBranchesData().subscribe(b => {
                this.loadingRequired = false;
                if( b != false ){
                    this.branches = b;
                }
            });

            this.login.getTeam().then(t => {
                if( (t == undefined) || (t == null) ){
                    t = 0;
                }
                
                this.usr_subsidiary = t;
            });
        });
    }

    clearData(){
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.summary_1 = [];
        this.summary_2 = [];
        this.summary_3 = [];
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-09-01';
        this.clearData();

        obj = {
            Start: this.f_datefrom,
            End: this.f_dateto,
            SubsidiaryId: (this.SubsidiaryId == 0) ? null : this.SubsidiaryId
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;

                this.summary_1 = rs.summary1;
                this.summary_2 = rs.summary2;
                this.summary_3 = rs.summary3;

                this.barChartData = [];
                this.barChartLabels = ['Conductor'];

                this.barChartData2 = [];
                this.barChartLabels2 = ['Ruta SAP'];

                this.pieChartLabels = [];
                this.pieChartData = [];

                //set pie chart labels
                if( Array.isArray(this.summary_1['detail']) ){
                	this.summary_1['detail'].forEach(x => {
                		this.pieChartLabels.push(x.fulfillment);
                		this.pieChartData.push(x.average.replace(/\s|%/g,''));
                	});
                }

                //set bar chart labels
                if( Array.isArray(this.summary_2['detail']) ){

                	this.summary_2['detail'].forEach(x => {
                		let tmp = {data:[], label:x['driver']};
	                	tmp.data.push(x.average);
	                	this.barChartData.push(tmp);
                	});

                	//hack to start y from 0
                	this.barChartData.push({data:[0], label:''});
                }

                //set bar chart 2 labels
                if( Array.isArray(this.summary_3['detail']) ){

                    this.summary_3['detail'].forEach(x => {
                        let tmp = {data:[], label:x['sapRoute']};
                        //this.barChartLabels2.push(x['sapRoute']);
                        tmp.data.push(x.average);
                        this.barChartData2.push(tmp);
                    });

                    //hack to start y from 0
                    this.barChartData2.push({data:[0], label:''});
                }

                this.rows = rs.details;
            }
        });
    }

    public clearFilters(){
    	this.sr_filter = '';
	    this.hr_filter = '';
	    this.driver_filter = '';
	    this.ds_filter = '';
	    this.rs_filter = '';

	    let today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = today;
        this.f_dateto = today;
    }

    exportReport(){
        this.exportAsService.save(this.exportAsConfig, 'kpi_serv_cliente').subscribe(() => {
          // save started
        });
    }

    public getBranchesData(){
        var par_url = 'Subsidiary/All';
        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

}
